import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconClose = ({ t, fill, className, height, width }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox='0 0 26 27'
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    <title>{t('Close')}</title>
    <defs>
      <rect width={39} height={39} rx={5} />
    </defs>
    <g transform='translate(-6 -6)' fill='none' fillRule='evenodd'>
      <g transform='rotate(135 17.586 18.914)'>
        <rect fill={fill} y={15.448} width={34} height={4} rx={2} />
        <rect
          fill={fill}
          transform='rotate(90 17 17.448)'
          y={15.448}
          width={34}
          height={4}
          rx={2}
        />
      </g>
    </g>
  </svg>
)

export default Icon(IconClose)
